<template>
  <div>
    <div class="row">
      <div class="col-sm-2">
      </div>
      <div class="col-sm-10">
        <div>
          <h2 style="font-weight: 600; margin-bottom: 0.5rem !important">
            Company Info
          </h2>
          <small style="font-size: 80% !important"
            >Choose an image that will be displayed at the top of your
            page</small
          >
        </div>
      </div>
    </div>
    <form action="" class="mt-4" v-if="inputs">
      <div class="form-row">
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("company_name") }}</label>
          <app-input type="text" :required="true" v-model="inputs.company_name" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("company_number") }}</label>
          <app-input type="text" :required="true" v-model="inputs.comapny_number" :read-only="inputType"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-6">
          <label for="user_company_phone_number">{{ $t("Company Phone") }}</label>
          <app-input type="number" :required="true" v-model="inputs.company_phone" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("email") }}</label>
          <app-input type="email" :required="true" v-model="inputs.company_email" :read-only="inputType"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-6">
          <label for="status">{{ $t("Status") }}</label>
          <app-input type="text" :disabled="true"  v-model="inputs.status" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="address" style="font-weight: 600;">{{ $t("address") }}</label>
          <div @click="openAddressModal" 
               class="address-field-prominent d-flex align-items-center justify-content-between p-2"
               style="cursor: pointer; border: 1px solid #ced4da; border-radius: 4px; background-color: #fff; min-height: 45px; transition: border-color 0.2s;">
              <span class="text-truncate mr-2" style="color: #495057; font-size: 0.95rem;">
                {{ inputs.address || $t('click_to_set_address') }}
              </span>
              <app-icon name="chevron-right" class="text-muted" style="font-size: 1.2rem;"/>
          </div>
        </div>
      </div>



      <div class="form-row">
        <div class="form-group col-6 mt-4">
          <app-input
            type="single-checkbox"
            :list-value-field="$t('non_uk_company')"
            v-model="otherDetail.non_uk_company"
          />
        </div>
        <div class="form-group col-6">
          <label for="co_registration_number">{{ $t("Registration Date") }}</label>
          <app-input type="date" v-model="otherDetail.co_registration_number" :read-only="inputType"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-6">
          <label for="vat_number">{{ $t("vat_number") }}</label>
          <app-input type="number" v-model="otherDetail.vat_number" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="duns_number">{{ $t("duns_number") }}</label>
          <app-input type="number" v-model="otherDetail.duns_number" :read-only="inputType"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-6">
          <label for="sme_status">{{ $t("sme_status") }}</label>
          <app-input
            type="select"
            :placeholder="$t('status')"
            :list="sme_status"
            v-model="otherDetail.sme_status"
          />
        </div>
        <div class="form-group col-6">
          <label for="last_submitted_by_vendor">{{ $t("last_submitted_by_vendor") }}</label>
          <app-input type="text" v-model="otherDetail.last_submitted_by_vendor" :read-only="inputType"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-6">
          <label for="environment_policy">{{ $t("environment_policy") }}</label>
          <app-input
            type="select"
            :placeholder="$t('environment_policy')"
            :list="status"
            v-model="otherDetail.environment_policy"
          />
        </div>
        <div class="form-group col-6">
          <label for="ssip_accredited">{{ $t("ssip_accredited") }}</label>
          <app-input
            type="select"
            :placeholder="$t('ssip_accredited')"
            :list="status"
            v-model="otherDetail.ssip_accredited"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-lg-3 col-md-3 col-sm-12">
          <app-input
            type="single-checkbox"
            :list-value-field="$t('cmdcoordinator')"
            v-model="otherDetail.cmdcoordinator"
          />
        </div>
        <div class="form-group col-lg-2 col-md-2 col-sm-12">
          <app-input
            type="single-checkbox"
            :list-value-field="$t('consultant')"
            v-model="otherDetail.consultant"
          />
        </div>
        <div class="form-group col-lg-2 col-md-2 col-sm-12">
          <app-input
            type="single-checkbox"
            :list-value-field="$t('designer')"
            v-model="otherDetail.designer"
          />
        </div>
        <div class="form-group col-lg-3 col-md-3 col-sm-12">
          <app-input
            type="single-checkbox"
            :list-value-field="$t('subcontractor')"
            v-model="otherDetail.subcontractor"
          />
        </div>
        <div class="form-group col-lg-2 col-md-2 col-sm-12">
          <app-input
            type="single-checkbox"
            :list-value-field="$t('supplier')"
            v-model="otherDetail.supplier"
          />
        </div>
      </div>

      <div class="form-row mt-4">
        <div class="col-12">
          <h5>UTR</h5>
        </div>
        <div class="form-group col-6">
          <label for="utr_number">{{ $t("utr_number") }}</label>
          <app-input type="number" v-model="otherDetail.utr_number" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="name_of_partner">{{ $t("name_of_partner") }}</label>
          <app-input type="text" v-model="otherDetail.name_of_partner" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="partners_utr_number">{{ $t("partners_utr_number") }}</label>
          <app-input type="number" v-model="otherDetail.partners_utr_number" :read-only="inputType"/>
        </div>
      </div>

    </form>
    <div class="d-flex justify-content-end" v-if="(userRole && userRole.company_id) === (inputs && inputs.id)">
         <button type="button" class="btn btn-primary" @click="alertModal">
                    {{ $t('Save changes') }}
         </button>   
    </div>
                <app-modal v-if="setModal"
                           :modal-id="modalId"
                           modal-alignment="center"
                           modal-size="md"
                           @close-modal="closeModal">
                    <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                        <div class="text-center">
                            <app-icon class="text-warning" :name="'alert-triangle'"/>
                        </div>
                        <h5 class="text-center font-weight-bold mt-4">{{ $t('alert')+'!' }}</h5>
                        <p class="text-center mb-4 font-size-90">{{ $t('Please enter password for verfication') }}</p>
                         <app-input type="password" :required="true" v-model="inputs.password" placeholder="Enter Password"/>
                         <small v-html="message" class="text-danger ml-2"></small>
                        <div class="text-center mt-3">
                            <a href="#" class="btn btn-warning" @click.prevent="updateModal">
                                {{ $t('continue') }}
                            </a>
                        </div>
                    </div>
                </app-modal>
                <app-modal v-if="addressModalSet"
                           :modal-id="addressModalId"
                           modal-alignment="center"
                           modal-size="lg"
                           @close-modal="closeAddressModal">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb bg-transparent p-0 mb-1">
                                    <li class="breadcrumb-item"><a href="#" @click.prevent="" style="color: #17a2b8;">Company Profile</a></li>
                                    <li class="breadcrumb-item active" aria-current="page" style="font-size: 0.85rem">Main Address</li>
                                </ol>
                            </nav>
                            <h3 class="modal-title font-weight-bold" style="color: #000 !important; font-weight: 800 !important;">Main Address</h3>
                        </div>
                        <button type="button" class="close" @click="closeAddressModal" style="font-size: 3.5rem; opacity: 1; color: #000; padding: 0.5rem 1.5rem; line-height: 1;">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-1" v-if="inputs">
                        <div class="form-group mb-2">
                          <label class="mb-0" style="font-size: 0.9rem; color: #000; font-weight: 600;">Country *</label>
                          <app-input type="text" :required="true" v-model="inputs.country" :read-only="inputType" style="background-color: #f4f4f4; border: none; height: 35px;"/>
                        </div>
                        
                        <div class="form-group mb-2">
                          <label class="mb-0" style="font-size: 0.9rem; color: #000; font-weight: 600;">Address Line 1 *</label>
                          <app-input type="text" :required="true" v-model="inputs.address_line_1" :read-only="inputType" style="background-color: #f4f4f4; border: none; height: 35px;"/>
                        </div>
                        
                        <div class="form-group mb-2">
                          <label class="mb-0" style="font-size: 0.9rem; color: #000; font-weight: 600;">Address 2 (Optional)</label>
                          <app-input type="text" v-model="inputs.address_line_2" :read-only="inputType" style="background-color: #f4f4f4; border: none; height: 35px;"/>
                        </div>
                        
                        <div class="form-group mb-2">
                          <label class="mb-0" style="font-size: 0.9rem; color: #000; font-weight: 600;">City *</label>
                          <app-input type="text" :required="true" v-model="inputs.city" :read-only="inputType" style="background-color: #f4f4f4; border: none; height: 35px;"/>
                        </div>

                        <div class="form-group mb-2">
                          <label class="mb-0" style="font-size: 0.9rem; color: #000; font-weight: 600;">ZIP/Postal Code *</label>
                          <app-input type="text" :required="true" v-model="inputs.postal_code" :read-only="inputType" style="background-color: #f4f4f4; border: none; height: 35px;"/>
                        </div>
                    </div>
                    <div class="modal-footer border-top-0 pt-0 justify-content-start">
                        <button type="button" class="btn btn-secondary px-4 py-2 mr-2" @click="closeAddressModal" style="background-color: #ddd; color: #555; border: none; font-weight: 600; font-size: 0.85rem;">
                            SAVE ADDRESS
                        </button>
                        <button type="button" class="btn btn-outline-info px-4 py-2" @click="closeAddressModal" style="font-weight: 600; font-size: 0.85rem; border-width: 1px;">
                            CANCEL
                        </button>
                    </div>
                </app-modal>
  </div>
</template>
<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import {COMPANY_INO_UPDATE} from "../../../../../app/Config/ApiUrl";
import {ModalMixin} from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  data() {
    return {
      //   readOnly: true,
      inputType: false,
      setModal: false,
      inputs: null,
      info: {},
      otherDetail: null,
      sme_status: [
        {id:'none', value:'None'},
        {id:'micro', value:'Micro'},
        {id:'small', value:'Small'},
        {id:'medium', value:'Medium'},
        {id:'large', value:'Large'}
      ],
      status: [
        {id:'yes', value:'Yes'},
        {id:'no', value:'No'},
      ],
      modalId: 'info-confirmation-modal',
      addressModalSet: false,
      addressModalId: 'address-detail-modal'
    };

  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
  mounted() {
    setTimeout(() => {
      this.inputs = this.$store.state.userCompanyProfile.dataProfile.company;
      this.otherDetail = this.$store.state.userCompanyProfile.dataProfile.company.other_detail ?? {};
    }, 1000);

    var url = window.location.pathname;
    var profileType = url.substring(url.lastIndexOf("/") + 1);
      if(profileType != 'my-profile') {
        this.inputType = true;
      }
    setTimeout(() => {
      this.inputs = this.$store.state.userCompanyProfile.dataProfile.company;
      this.otherDetail = this.$store.state.userCompanyProfile.dataProfile.company.other_detail ?? {};
    }, 1000);
  },
  methods: {
  alertModal(){
    // mark submit so inputs display validation state
    this.fieldStatus = this.fieldStatus || {};
    this.fieldStatus.isSubmit = true;

    // reuse form mixin validation so all required fields (including both address and postal)
    // report errors consistently
    if (!this.isValidForm()) {
      return;
    }

    this.message = '';
    this.setModal = true;
  },
    updateModal(){
      if (this.inputs.password == null) {
          this.message = 'Password Field Is Required';
      }
      else {
          this.info = {
            'company_name': this.inputs.company_name,
            'comapny_number': this.inputs.comapny_number,
            'company_email': this.inputs.company_email,
            'address_line_1': this.inputs.address_line_1,
            'address_line_2': this.inputs.address_line_2,
            'company_phone':this.inputs.company_phone,
            'country': this.inputs.country,
            'city': this.inputs.city,
            'postal_code': this.inputs.postal_code,
            'premises': this.inputs.premises,
            'address': this.inputs.address,
            'password': this.inputs.password,
          };
          this.info.otherDetail = this.otherDetail;
        axiosPost(COMPANY_INO_UPDATE, this.info)
          .then((res) => {

            if (res.data.message) {
              this.$toastr.s(res.data.message);
            }
            else {
            this.$toastr.w(res.data.info);
            }
            // $('#alert-modal').hide();
            // this.setModal = false;
          })
          .catch((error) => {
            
            this.$toastr.e(error.data.type);
          })
          .finally(() => {
            // location.reload();
            this.preloader = false;
            this.closeModal();
            $('#' + this.modalId).modal('hide');

          });
      }
      // this.setModal = false;
    },
    openAddressModal() {
      if (!this.inputType) {
        this.addressModalSet = true;
        setTimeout(() => {
          $('#' + this.addressModalId).modal('show');
        }, 100);
      }
    },
    closeAddressModal() {
      $('#' + this.addressModalId).modal('hide');
      $('.modal-backdrop').remove(); // Force remove backdrop if it gets stuck
      this.addressModalSet = false;
    },
    updateFullAddress() {
      const { address_line_1, address_line_2, city, postal_code, country } = this.inputs;
      this.inputs.address = address_line_1 + 
                            (address_line_2 ? ' ' + address_line_2 : '') + 
                            (city ? ', ' + city : '') + 
                            (postal_code ? ', ' + postal_code : '') + 
                            (country ? ', ' + country : '');
    }

  },
  watch: {
    'inputs.premises': function() { this.updateFullAddress(); },
    'inputs.address_line_1': function() { this.updateFullAddress(); },
    'inputs.address_line_2': function() { this.updateFullAddress(); },
    'inputs.city': function() { this.updateFullAddress(); },
    'inputs.postal_code': function() { this.updateFullAddress(); },
    'inputs.country': function() { this.updateFullAddress(); },
  }
};
</script>

<style scoped>
.address-field-prominent:hover {
  border-color: #17a2b8 !important;
}
</style>